import FilterSuperCashback from './FilterSuperCashback';

export default FilterSuperCashback;
